<template>
  <span
    class="inline-flex shrink-0 items-center justify-center align-middle text-sky-400"
    :class="sizeClass"
    :title="title"
    aria-label="Verified profile"
  >
    <svg viewBox="0 0 24 24" class="h-full w-full" fill="currentColor" aria-hidden="true">
      <path d="M12 2.75l2.29 1.42 2.67-.13 1.42 2.29 2.29 1.42-.13 2.67L21.96 12l-1.42 2.29.13 2.67-2.29 1.42-1.42 2.29-2.67-.13L12 21.25l-2.29-1.42-2.67.13-1.42-2.29-2.29-1.42.13-2.67L2.04 12l1.42-2.29-.13-2.67 2.29-1.42 1.42-2.29 2.67.13L12 2.75z" />
      <path d="M10.4 14.8 7.7 12.1l-1.1 1.1 3.8 3.8 7-7-1.1-1.1z" fill="#0b0f14" />
    </svg>
  </span>
</template>

<script>
export default {
  name: 'VerifiedBadge',
  props: {
    size: {
      type: String,
      default: 'sm',
    },
    title: {
      type: String,
      default: 'Verified',
    },
  },
  computed: {
    sizeClass() {
      if (this.size === 'xs') return 'h-3.5 w-3.5'
      if (this.size === 'lg') return 'h-5 w-5'
      return 'h-4 w-4'
    },
  },
}
</script>
